{
  "name": "@jspsych/extension-pipe",
  "version": "0.2.0",
  "description": "jsPsych extension for sending data to DataPipe",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jspsych/jsPsych.git",
    "directory": "packages/extension-pipe"
  },
  "author": "Josh de Leeuw",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jsPsych/issues"
  },
  "homepage": "https://www.jspsych.org/latest/extensions/pipe",
  "dependencies": {
    "datapipe-client": "^0.1.0"
  },
  "peerDependencies": {
    "jspsych": ">=8.0.0"
  },
  "devDependencies": {
    "@jspsych/config": "^3.4.0",
    "@jspsych/test-utils": "^1.2.0"
  }
}
